import React from 'react'
import ReactDOM from 'react-dom'
import ReactModal from 'react-modal'
import './styles.css'

type Props = {
    isOpen: boolean
    onRequestClose: () => void
    children: any
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    innerWidth: '300px',
    maxWidth: '500px'
  }
}

export const Modal: React.FC<Props> = ({
  isOpen,
  onRequestClose,
  children
}) => {

  return ReactDOM.createPortal(
    <ReactModal isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles}>
      { children }
    </ReactModal>
    , document.body)
}

export const ModalActions: React.FC<{
    onCancel?: () => void
    onSubmit?: () => void
    loading?: boolean
    submitText?: string
    submit?: boolean
}> = ({
  onCancel,
  onSubmit,
  loading,
  submitText,
  submit
}) => {
  return (
    <div className="modal-actions">
      { onCancel && (
        <button className="secondary" type="button" onClick={onCancel} disabled={loading}>
                    Close
        </button>
      )}
      { onSubmit && (
        <button className="primary" type="submit" onClick={onSubmit} disabled={loading}>
          { submitText || 'Submit' }
        </button>
      )}
      {
        submit && (
          <button className="primary" type="submit" disabled={loading}>
            { submitText || 'Submit' }
          </button>
        )
      }
    </div>
  )
}
